import { defineComponent, computed, openBlock, createElementBlock, createVNode, unref } from "vue";
import { CdrFilmstrip } from "@rei/cedar";
import { adapter } from "./adapter.mjs";
const _hoisted_1 = {
  class: "image-carousel"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsImageCarousel",
  props: {
    photoArr: {},
    reviewArr: {}
  },
  emits: ["openMapModal", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const computedReviewArr = computed(() => props.reviewArr);
    const emit = __emit;
    const productReviewsImageCarouselModelData = {
      items: props.photoArr
    };
    function onFrameClick(payload) {
      const {
        item
      } = payload;
      emit("openMapModal", {
        reviews: computedReviewArr,
        photoIndex: item.photoIndex,
        reviewIndex: item.reviewIndex
      });
    }
    function fireImageScrollEvent() {
      emit("metricsClick", {
        linkName: "reviews_image scroll"
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(CdrFilmstrip), {
        class: "image-carousel__filmstrip",
        model: productReviewsImageCarouselModelData,
        adapter: unref(adapter),
        onFrameClick,
        onArrowClick: fireImageScrollEvent,
        onScrollNavigate: fireImageScrollEvent
      }, null, 8, ["adapter"])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsImageCarousel2.mjs.map
